import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyEditContact = lazyWithRetry(() => import("./EditContact"));

const EditContact = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyEditContact {...props} />;

export default EditContact;
